import { Box, Button, Container, Grid, Paper, Typography,  } from "@mui/material";
import { NavLink } from "react-router-dom";

export default function GuestFooter() {
  return (
      <Paper sx={{marginTop: 10,
                width: '100%',
                bottom: 0,
                }} component="footer" square variant="outlined">
      <Container maxWidth="lg">
      <Box sx={{ flexGrow: 1, display: 'flex'  }}>
          <Grid container rowSpacing={0}>
              <Grid item xs={12} sm={6} md={4} style={{textAlign: "center"}}>
                <Button
                    component={NavLink}
                    to={'/shipping'}
                    // onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'inherit', display: 'block',  }}
                   
                  >
                    Shipping Fee policy
                  </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={4} style={{textAlign: "center"}}>
                  <Button
                    component={NavLink}
                    to={'/refund'}
                    // onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'inherit', display: 'block' }}
                  >
                    Refund and Care
                  </Button>
              </Grid>  
              <Grid item xs={12} sm={6} md={4} style={{textAlign: "center"}}>
                  <Button
                    component={NavLink}
                    to={'/terms-and-policy'}
                    // onClick={handleCloseNavMenu}
                    sx={{ my: 2, color: 'inherit', display: 'block' }}
                  >
                    Terms of Service and Privacy
                  </Button>
              </Grid>            
          </Grid> 
        </Box>

        <Box
          sx={{
            flexGrow: 1,
            justifyContent: "center",
            display: "flex",
            mb: 2,
            mt: 2
          }}
        >
          <Typography variant="body2" color="initial">
            Copyright ©2023 Home Base Enamels
          </Typography>
        </Box>
      </Container>
    </Paper>
  );
}